const WP_DATA_OBJ = (window && window.wp_data) && window.wp_data

const formatNumFieldVals = data => {
  const json = JSON.parse(data)
  Object.entries(json).forEach(item => {
    const [section, items] = item
    Object.entries(items).forEach(item => {
      const [itemTitle, fields] = item
      Object.entries(fields).forEach(field => {
        const [key, value] = field
        const int = parseInt(value)
        if (typeof int === 'number' && !isNaN(int)) {
          json[section][itemTitle][key] = int
        }
      })
    })
  })
  return json
}

export const WP_DATA = WP_DATA_OBJ ? (
  Object.entries(WP_DATA_OBJ).reduce((prev, curr) => {
    const [ k, v ] = curr
    k === 'worksheet_data'
      ? prev[k] = formatNumFieldVals(v)
      : prev[k] = v
    return prev
  }, {})
) : null

export default WP_DATA